// categoryActions.js — DealCouponz pattern: thunks → categoryServices
import * as categoryTypes from "../types/categoryTypes";
import * as categoryServices from "../../services/categoryServices";

export const getCategories = () => async (dispatch) => {
  dispatch({ type: categoryTypes.GET_CATEGORIES_REQUEST });
  try {
    const data = await categoryServices.getAllCategories();
    dispatch({ type: categoryTypes.GET_CATEGORIES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: categoryTypes.GET_CATEGORIES_FAILURE,
      payload: error?.message || "Failed to load categories",
    });
  }
};
